module.exports = __webpack_public_path__ + "img/qy (46).40372997.jpg";